import { Heading, HeadingTag } from "components/common/Heading";
import { ValidInputField } from "components/common/InputField";
import {
  AboutYou,
  emailValidation,
  firstnameValidation,
  lastnameValidation,
  phoneNumberValidation,
  validateAboutYou,
  validateConfirmEmailAboutYou,
} from "domain/aboutYou";
import React, { useCallback, useMemo } from "react";
import { BANNER_TEXT1, BANNER_TEXT2, COUNTRY_CODE } from "./AboutYouForm.const";
import { Button, Col, FormGroup } from "reactstrap";
import { isValid } from "validation/validation";
import {
  Notification,
  Status,
} from "components/common/Notification/Notification";

type AboutYouFormProps = {
  aboutYou: AboutYou;
  onSubmit: (ay: AboutYou) => void;
};

export const AboutYouForm = (props: AboutYouFormProps) => {
  const [aboutYou, setAboutYou] = React.useState<AboutYou>(props.aboutYou);

  const validateForm = useCallback(
    () => validateAboutYou(aboutYou),
    [aboutYou]
  );
  const isFormValid = isValid(validateForm);
  const valid = useMemo(() => isFormValid(aboutYou), [aboutYou, isFormValid]);

  return (
    <div className="narrow-container">
      <Col className="content-wrapper sticky-container">
        <div>
          <Heading
            tag={HeadingTag.h1}
            size={1}
            className="zb-heading1 screen-header"
            title="About You"
          />
          <div>
            <Notification title={""} status={Status.INFO}>
              <p>{BANNER_TEXT1}</p>
              <p>{BANNER_TEXT2}</p>
            </Notification>

            <ValidInputField
              value={aboutYou.firstName}
              aria-describedby="firstName"
              onChange={(firstName) => setAboutYou({ ...aboutYou, firstName })}
              id="firstName"
              name="firstName"
              validate={firstnameValidation}
              label="First name"
            />
            <ValidInputField
              value={aboutYou.lastName}
              onChange={(lastName) => setAboutYou({ ...aboutYou, lastName })}
              id="lastName"
              name="lastName"
              validate={lastnameValidation}
              label="Last name"
            />
            <ValidInputField
              value={aboutYou.email}
              onChange={(email) => setAboutYou({ ...aboutYou, email })}
              id="email"
              name="email"
              validate={emailValidation}
              label="Email address"
            />
            <ValidInputField
              stopPaste
              value={aboutYou.confirmEmail}
              onChange={(confirmEmail) =>
                setAboutYou({ ...aboutYou, confirmEmail })
              }
              id="confirmEmail"
              name="confirmEmail"
              validate={(confirmEmail) =>
                validateConfirmEmailAboutYou({ ...aboutYou, confirmEmail })
              }
              label="Confirm email address"
            />
            <FormGroup>
              <div className="phoneNumber-container">
                <div className="country-code">+{COUNTRY_CODE}</div>
                <ValidInputField
                  value={aboutYou.phoneNumber}
                  onChange={(phoneNumber) =>
                    setAboutYou({ ...aboutYou, phoneNumber })
                  }
                  id="mobileNumber"
                  name="mobileNumber"
                  validate={phoneNumberValidation}
                  label="Your mobile number"
                />
              </div>
            </FormGroup>
          </div>
        </div>
        <div className="button-end">
          <Button
            color="primary"
            size="lg"
            disabled={!valid}
            onClick={() => props.onSubmit(aboutYou)}
          >
            Next
          </Button>
        </div>
      </Col>
    </div>
  );
};
